import { useId, useState } from "react";
import { H2, Label, RadioGroup, Text, View } from "tamagui";
import { Card } from "./components/radioParts.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const data = [{
  id: "ver-1-paypal",
  label: "PayPal",
  icon: "paypal"
}, {
  id: "ver-1-mastercard",
  label: "Mastercard",
  icon: "mastercard"
}, {
  id: "ver-1-visa",
  label: "Visa",
  icon: "visa"
}];
function Vertical() {
  const uniqueId = useId();
  const [value, setValue] = useState("hor-visa");
  return /* @__PURE__ */jsx(View, {
    width: "100%",
    items: "center",
    children: /* @__PURE__ */jsxs(View, {
      flexDirection: "column",
      minW: "100%",
      "$group-window-gtSm": {
        maxW: 400,
        minW: 400
      },
      gap: "$4",
      children: [/* @__PURE__ */jsxs(View, {
        flexDirection: "column",
        gap: "$2",
        children: [/* @__PURE__ */jsx(H2, {
          children: "Payment"
        }), /* @__PURE__ */jsx(Text, {
          fontWeight: "300",
          color: "$color9",
          children: "Select your payment method"
        })]
      }), /* @__PURE__ */jsx(RadioGroup, {
        "$group-window-gtSm": {
          maxW: 400
        },
        flexWrap: "wrap",
        gap: "$2",
        flexDirection: "column",
        value,
        onValueChange: setValue,
        children: data.map(({
          id,
          label,
          icon
        }) => /* @__PURE__ */jsxs(Card, {
          p: 0,
          flexDirection: "row",
          items: "center",
          gap: "$3",
          px: "$2.5",
          active: value === id,
          onPress: () => setValue(id),
          children: [/* @__PURE__ */jsx(View, {
            onPress: e => e.stopPropagation(),
            children: /* @__PURE__ */jsx(RadioGroup.Item, {
              id: uniqueId + id,
              value: id,
              children: /* @__PURE__ */jsx(RadioGroup.Indicator, {})
            })
          }), /* @__PURE__ */jsx(Label, {
            cursor: "pointer",
            htmlFor: uniqueId + id,
            children: label
          })]
        }, id))
      })]
    })
  });
}
Vertical.fileName = "Vertical";
function VerticalRadioGroupControlled(props) {
  const uniqueId = useId();
  const onValueChange = value => {
    props.onChange(value);
  };
  return /* @__PURE__ */jsxs(View, {
    flexDirection: "column",
    minW: "100%",
    "$group-window-gtSm": {
      maxW: 400,
      minW: 400
    },
    gap: "$4",
    children: [props.title || props.label ? /* @__PURE__ */jsxs(View, {
      flexDirection: "column",
      gap: "$2",
      children: [props.title ? /* @__PURE__ */jsx(H2, {
        children: props.title
      }) : null, props.label ? /* @__PURE__ */jsx(Text, {
        fontWeight: "300",
        fos: "15px",
        children: props.label
      }) : null]
    }) : null, /* @__PURE__ */jsx(RadioGroup, {
      "$group-window-gtSm": {
        maxW: 400
      },
      flexWrap: "wrap",
      gap: "$2",
      flexDirection: "column",
      value: props.value !== void 0 ? props.value : "",
      onValueChange,
      children: props.items.map(({
        value,
        label
      }, idx) => /* @__PURE__ */jsxs(Card, {
        padding: 0,
        flexDirection: "row",
        alignItems: "center",
        gap: "$3",
        paddingHorizontal: "$2.5",
        active: props.value === value,
        onPress: () => onValueChange(value),
        style: props.error ? {
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: "rgb(255, 107, 107)"
        } : void 0,
        children: [/* @__PURE__ */jsx(View, {
          onPress: e => e.stopPropagation(),
          children: /* @__PURE__ */jsx(RadioGroup.Item, {
            id: uniqueId + value,
            value,
            children: /* @__PURE__ */jsx(RadioGroup.Indicator, {})
          })
        }), /* @__PURE__ */jsx(Label, {
          cursor: "pointer",
          htmlFor: uniqueId + value,
          children: label
        })]
      }, uniqueId + value + idx))
    })]
  });
}
export { Vertical, VerticalRadioGroupControlled };
//# sourceMappingURL=Vertical.mjs.map
